import React from 'react'
import "../Assets/styles/footer.css"

const Footer = () => {
  return (
    <>
        <div className="footer-section">
        <div className="container-lg">
            <div className="subscribe-area">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6">
                        <div className="subscribe-content">
                            <h2>Join Our Newsletter</h2>
                            <p>News letter dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <form className="newsletter-form">
                            <input type="email" className="input-newsletter" placeholder="Enter your email" name="email" required=""/>
                            <button type="submit">Subscribe Now</button>
                        </form>
                    </div>
                </div>
            </div>
            <div className="row">
                
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="single-footer-widget">
                        <div className="footer-heading">
                            <h3>Important Links</h3>
                        </div>
                        <ul className="russian-link">
                            <li>
                                <a href="/about/">About Us</a>
                            </li>
                            <li>
                                {/* <a href="/services/">Services</a> */}
                            </li>
                            <li>
                                <a href="/contact/">Contact</a>
                            </li>
                            <li>
                                <a href="/terms-conditions/">Terms & Conditions</a>
                            </li>
                            <li>
                                <a href="/privacy-policy/">Privacy Policy</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 foot-right">
                    <div className="single-footer-widget">
                        <div className="footer-heading">
                            <h3>Featured Service</h3>
                        </div>
                        <ul className="russian-link">
                            <li>
                                <a href="/about/">IT Management</a>
                            </li>
                            <li>
                                <a href="/about/">Development</a>
                            </li>
                            <li>
                                <a href="/about/">Service</a>
                            </li>
                            <li>
                                <a href="/about/">UI/UX Design</a>
                            </li>
                            <li>
                                <a href="/about/">Support Engineer</a>
                            </li>
                        </ul>
                    </div>
                </div>
                {/* <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="single-footer-widget">
                        <div className="footer-heading">
                            <h3>Contact</h3>
                        </div>
                        <div className="footer-info-contact">
                            <img src={Phone} height={25} alt='hg' className="flaticon-phone-call"/>
                            <h3>Phone</h3>
                            <span>+2348045764123</span>
                        </div>
                        <div className="footer-info-contact">
                            <img src={emm} height={25} alt='gh' className="flaticon-envelope"/>
                            <h3>Email</h3>
                            <span>
                                Itbt@gmail.com
                            </span>
                        </div>
                        <div className="footer-info-contact">
                            <img src={globe} alt="fhg" height={25} />                                
                            <h3>Address</h3>
                            <span>Sam Etnam Air Force Base, Lagos, Nigeria</span>
                        </div>
                    </div>
                </div> */}
            </div>
        </div>
        </div>
    </>
  )
}

export default Footer